module.exports = __webpack_public_path__ + "media/images/features/modification/list-mv-3258a798a0c2c670786b8747284ad015.png";